import React from "react";
import Select from "react-select";

export type Option = {
  value: string;
  label: string;
};

export interface SelectProps {
  options: Option[];
  value?: Option | null; // Use value instead of defaultValue
  className?: string;
  styles?: any;
  onChange?: (option: Option | null) => void;
}

const CommonStatusSelect: React.FC<SelectProps> = ({ options, value, className, onChange }) => {
  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      options={options}
      value={value} // Use value directly as a controlled prop
      onChange={onChange} // Pass the handler directly
      placeholder="Select"
      isClearable
    />
  );
};

export default CommonStatusSelect;
